module.exports = __webpack_public_path__ + "img/500px.a7dc1326.svg";